// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentCard_wrapper__xczIw","info_wrapper":"DocumentCard_info_wrapper__qf-br","button":"DocumentCard_button__HSUWA","date":"DocumentCard_date__9FyxM"};